import { render } from "./ChoikuLove.vue?vue&type=template&id=36c89260"
import script from "./ChoikuLove.vue?vue&type=script&lang=js"
export * from "./ChoikuLove.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ChoikuLove.vue?vue&type=style&index=0&id=36c89260&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__